import { Checkbox, Switch, Tooltip } from '@bp/ui-components';
import classNames from 'classnames';
import { Field, FieldArrayRenderProps, useFormikContext } from 'formik';
import { ChangeEvent } from 'react';
import { InheritClassesFormType } from './InheritClassesForm';
import styles from './InheritClassesFormRow.module.scss';

type InheritClassesFormRowProps = {
  index: number;
  helper: FieldArrayRenderProps;
};

export const InheritClassesFormRow = ({ index, helper }: InheritClassesFormRowProps) => {
  const { values, setFieldValue } = useFormikContext<InheritClassesFormType>();

  const {
    selected,
    name,
    grade,
    gradeGroupName,
    shortName,
    tutorName1,
    tutorName2,
    tutorName3,
    roomName,
    color,
    colorLabel,
    inheritColor,
  } = values[index];

  return (
    <div className={classNames(styles['inherit-classes-form-row'], { [styles.selected]: selected })}>
      <div className={styles.checkbox}>
        <Field
          as={Checkbox}
          name={`${helper.name}.${index}.selected`}
          checked={selected}
          onChange={async (e: ChangeEvent<HTMLInputElement>) =>
            await setFieldValue(`${index}.selected`, e.target.checked)
          }
        />
      </div>

      <div className={styles.medium}>{name}</div>
      <div className={styles.small}>{grade}</div>
      <div className={styles.small}>{gradeGroupName}</div>
      <div className={styles['short-name']}>{shortName}</div>
      <div className={styles.large}>{tutorName1}</div>
      <div className={styles.large}>{tutorName2}</div>
      <div className={styles.large}>{tutorName3}</div>
      <div className={styles.large}>{roomName}</div>
      <div className={styles.small}>
        <Tooltip
          triggerClass={styles['tooltip-fix']}
          content={colorLabel && colorLabel !== '' ? colorLabel : '#FFFFFF'}
        >
          <div className={styles['color-dot']} style={{ backgroundColor: color }}></div>
        </Tooltip>
      </div>
      <div className={styles.small}>
        <Field
          as={Switch}
          name={`${helper.name}.${index}.inherit-color`}
          checked={inheritColor}
          onChange={async (e: ChangeEvent<HTMLInputElement>) =>
            await setFieldValue(`${index}.inheritColor`, e.target.checked)
          }
          disabled={!selected}
        />
      </div>
    </div>
  );
};
